export const top_amenities = [
    {
        fact: "88",
        value: "21",
        icon: 'wifi'
    }, {
        fact: "22",
        value: "21",
        icon: 'local_parking'
    }, {
        fact: "96",
        value: "21",
        icon: 'breakfast_dining'
    }, {
        fact: "220",
        value: "69",
        icon: 'fitness_center'
    }, {
        fact: "43",
        value: true,
        icon: 'pool'
    }, {
        fact: "66",
        value: true,
        icon: 'room_service'
    }, {
        fact: "19",
        value: true,
        icon: 'business_center'
    }, {
        fact: "53",
        value: "3",
        icon: 'pets'
    }, {
        fact: "45",
        value: true,
        icon: 'local_laundry_service'
    }, {
        fact: "156",
        value: true,
        icon: 'local_bar'
    }, {
        fact: "170",
        value: true,
        icon: 'smoking_rooms'
    }
];

export const accommodation_types = [
    {
        label: "Palace/castle hotel",
        value: "411"
    }, {
        label: "Camper Van",
        value: "430"
    }, {
        label: "Hotel",
        value: "404"
    }, {
        label: "Resort",
        value: "414"
    }, {
        label: "Ranch",
        value: "416"
    }, {
        label: "Lodge",
        value: "278"
    }, {
        label: "Inn",
        value: "407"
    }, {
        label: "Farm",
        value: "415"
    }, {
        label: "Countryside Hotel",
        value: "408"
    }, {
        label: "Apartment Complex",
        value: "413"
    }, {
        label: "Apartment Hotel",
        value: "253"
    }, {
        label: "Campsite",
        value: "260"
    }
]